export var ReviewLetterSignatureType;
(function (ReviewLetterSignatureType) {
    ReviewLetterSignatureType[ReviewLetterSignatureType["Reviewer"] = 0] = "Reviewer";
    ReviewLetterSignatureType[ReviewLetterSignatureType["Approver"] = 1] = "Approver";
})(ReviewLetterSignatureType || (ReviewLetterSignatureType = {}));
